.wrapper {
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	padding: 20px;
	transition: all 0.5s;
	align-items: center;
}
.hide {
	transform: translateX(-50px);
	opacity: 0;
	visibility: hidden;
}

.count {
	font-size: 36px;
}
.noCount .count {
	display: none;
}
.crystals {
	height: 50px;
	--crystal-size: 40px;
	--health: 1;
	background-image: url("../assets/health-crystal.svg");
	background-size: var(--crystal-size);
	width: calc(var(--crystal-size) * var(--health));
	transition: width 0.5s;
}
.hide .crystals {
	--health: 0;
	transform: none;
}
